<app-section #parentSection
             class="offer-modifications offer-modifications--additional-options"
             *ngIf="sectionVisible"
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig">

  <ng-template #section>

<!--    <div class="offer-modifications__recalculate-btn-wrapper">-->
<!--      <button class="btn btn&#45;&#45;primary-inverted btn&#45;&#45;big btn&#45;&#45;fab offer-modifications__recalculate-btn"-->
<!--              id="recalculate-btn"-->
<!--              *ngIf="buttonVisible"-->
<!--              (click)="recalculatePremium()">-->
<!--        {{ 'OFFER_MODIFICATIONS.recalculatePremium' | translate }}-->
<!--      </button>-->
<!--    </div>-->

    <div *ngIf="contentVisible"
         class="offer-modifications__content">
        <div *ngFor="let mod of visibleModifications"
             [class]="'offer-modifications__modification offer-modifications__modification--' + mod.code"
             [ngClass]="{'offer-modifications__modification--with-select': offerModificationsService.isModificationWithSelect(mod.code)}"
        >
            <app-radio-tile [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[mod.code]"
                            [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
            </app-radio-tile>

            <a *ngIf="mod.code === ModificationCode.ASSISTANCE" class="offer-modifications__link-btn offer-modifications__compare-btn" (click)="compareCoverages()">
                {{ 'OFFER_MODIFICATIONS.compareCoverages' | translate }}
            </a>

            <app-select *ngIf="offerModificationsService.isModificationWithSelect(mod.code)"
                        #select
                        [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[mod.code + '-value']"
                        [fieldConfig]="formFactoryService.fieldConfig(mod.code + '-value', formConfig)"
                        (interactiveClick)="onSelectInteractiveClick()">
            </app-select>
        </div>

        <a *ngIf="expandModificationsButtonVisible" class="offer-modifications__link-btn" (click)="toggleVisibility()">
            <span *ngIf="!allModificationsVisible">{{ 'OFFER_MODIFICATIONS.expand' | translate }}</span>
            <span *ngIf="allModificationsVisible">{{ 'OFFER_MODIFICATIONS.collapse' | translate }}</span>
        </a>

        <div *ngIf="allModificationsVisible">
            <div *ngFor="let mod of invisibleModifications" class="offer-modifications__modification">
                <app-radio-tile [bean]="bean"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[mod.code]"
                                [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                                (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
                </app-radio-tile>
            </div>
        </div>
    </div>

      <div *ngIf="!contentVisible"
           class="offer-modifications__content-placeholder">
          <app-loading-content-placeholder [config]="loadingContentPlaceholderConfig"
          ></app-loading-content-placeholder>
      </div>

  </ng-template>
</app-section>

<app-driver-sos-details-banner *ngIf="bannerVisible"></app-driver-sos-details-banner>
